import { eventProperties } from './events';

export const isString = (a) => typeof a === 'string' || a instanceof String;

export const getRandomNumber = (a = 0, b = 1073741824) => {
  return Math.floor(Math.random() * (b - a)) + a;
};

export const apiHelper = (
  externalId,
  extraValues,
  abParams,
  eventType,
  obj = {}
) => {
  if (eventType !== 2) {
    eventProperties.scrollFirst = false;
    eventProperties.scrollMiddle = false;
    eventProperties.scrollBottom = false;
  }

  const data = {
    et: eventType,
    eid: obj.eid || externalId,
    exv: obj.exv ? obj.exv : extraValues,
    ev: obj.ev,
    abParams: typeof obj.abParams === 'object' ? obj.abParams : abParams,
  };

  return data;
};

export const parseData = (data) => {
  if (typeof data === 'object') {
    return data;
  }
  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
};

export const getHrefWithAnchor = (href, newParam, separator) => {
  const splitHref = href.split('/');
  const lastSegment = splitHref[splitHref.length - 1];
  const anchorIndex = lastSegment.indexOf('#');

  if (anchorIndex !== -1) {
    const splitAnchor = lastSegment.split('#');
    return `${splitHref.slice(0, -1).join('/')}/${
      splitAnchor[0]
    }${separator}${newParam}#${splitAnchor[1]}`;
  }

  return `${href}${separator}${newParam}`;
};

export const formDataToObject = (formData) => {
  const object = {};
  for (let [key, value] of formData.entries()) {
    object[key] = value;
  }
  return object;
};
